export default "__VITE_ASSET__DzlLcphY__"